import styled from 'styled-components';
import bg_01 from '../../assets/images/bg_01.png';
import bg_02 from '../../assets/images/bg_02.png';

export const Wrapper = styled.div`
  background: #ffffff;
`;

export const Container = styled.div`
  .bg{
    width:100%;display:block;
  }
  .list{
    padding:0 .3rem;
    .item{
      margin-top:.5rem;height: .9rem;background: #FFFFFF;box-shadow: 0px .06rem .19rem .04rem rgba(33, 51, 78, 0.07);border-radius: .45rem;
      display:flex;align-items:center;justify-content:center;padding:0 .55rem 0 .44rem;
      .label{
        width:.3rem;height: .42rem;display:block;margin-right:.4rem;
      }
      input{
        height:.8rem;font-size: .28rem;font-weight: 400;color: #3B3D41;flex:1;border: 0px;outline: none;
      }
      input::-webkit-input-placeholder{
        color: #C9CCD1;
      }
      .code{
        font-size: .28rem;font-weight: 400;color: #5799FF;
      }
      .code.err{
        color: #C9CCD1;
      }
    }
    .item:nth-child(1){
      margin-top:.6rem;
    }
  }
  .btns{
    padding:0 .3rem;margin-top:.9rem;
    .btn{
      height: .9rem;background: #5799FF;box-shadow: 0px .06rem .19rem .04rem rgba(57, 99, 163, 0.3);border-radius: .45rem;
      font-size: .36rem;font-weight: 400;color: #FFFFFF;line-height: .9rem;text-align:center;
    }
  }

  .component{
    width: 100%;height: 100%;background: rgba(0,0,0,0);transition: all .25s;position: fixed;top:0;left: 0;z-index: 101;
    display: flex;flex-direction:column;align-items: center;justify-content: center;overflow: hidden;padding:0 .3rem;
    .componentor{
      width:100%;opacity: 1;transition: all .25s;height:auto;border-radius:.1rem;overflow:hidden;
      .bg_01{
        background:url(${bg_01}) no-repeat;height:1.7rem;background-size:100% 100%;padding-right:.34rem;
        display: flex;flex-direction:column;align-items: flex-end;justify-content: center;
        span{
          height:.42rem;line-height:.42rem;font-size: .32rem;font-weight: 400;color: #595E89;display:block;
        }
      }
      .title{
        display: flex;align-items: center;justify-content: center;
        span{
          font-size: .36rem;font-weight: 500;color: #595E89;margin:-.1rem .22rem 0;
        }
        img{
          width:.29rem;height:.42rem;display:block;
        }
      }
      .msg{
        font-size: .28rem;font-weight: 400;color: #595E89;line-height: .42rem;text-align:center;margin-top:.2rem;padding: 0 .5rem;
      }
      .bg_02{
        background:#ffffff;padding:.44rem 0 .34rem;
      }
      .bg_03{
        /* background:#F5F5F5;padding:.4rem 0; */
        background:#F5F5F5;padding:.2rem 0;
        .phone{
          display: flex;align-items: center;justify-content: center;margin-top:.22rem;height:.28rem;
          span{
            font-size: .32rem;font-weight: 400;color: #2B84FC;
          }
          b{
            font-size: .28rem;font-weight: 400;color: #2B84FC;margin-left:.52rem;
          }
        }
        .msg{
          /* margin-top:.48rem; */
        }
        .code{
          width:100%;display:block;margin:.2rem auto 0;
        }
      }
    }
    .close{
      width:.7rem;height:.7rem;margin:.6rem auto 0;border-radius:50%;overflow:hidden;transition: all .25s;
      img{
        width:100%;height:100%;display:block;
      }
    }
  }
  .component.show{
    visibility: show;background: rgba(0,0,0,.7);
  }
  .component.hide{
    visibility: hidden;
    .componentor,.close{
      opacity: 0;
    }
  }

  .component2{
    width: 100%;height: 100%;background: rgba(0,0,0,0);transition: all .25s;position: fixed;top:0;left: 0;z-index: 101;
    display: flex;flex-direction:column;align-items: center;justify-content: center;overflow: hidden;padding:0 .3rem;
    .componentor{
      width:100%;opacity: 1;transition: all .25s;height:auto;border-radius:.1rem;overflow:hidden;
      .bg_01{
        background:url(${bg_02}) no-repeat;height:1.7rem;background-size:100% 100%;padding-right:.34rem;
        display: flex;flex-direction:column;align-items: flex-end;justify-content: center;
        span{
          height:.42rem;line-height:.42rem;font-size: .32rem;font-weight: 400;color: #A26466;display:block;
        }
      }
      .title{
        display: flex;align-items: center;justify-content: center;
        span{
          font-size: .36rem;font-weight: 500;color: #A26466;margin:-.1rem .22rem 0;
        }
        img{
          width:.29rem;height:.42rem;display:block;
        }
      }
      .msg{
        font-size: .28rem;font-weight: 400;color: #A26466;line-height: .42rem;text-align:center;margin-top:.2rem;padding: 0 .5rem;
      }
      .bg_02{
        background:#ffffff;padding:.44rem 0 .34rem;
      }
      .bg_03{
        /* background:#F5F5F5;padding:.4rem 0; */
        background:#F5F5F5;padding:.2rem 0;
        .phone{
          display: flex;align-items: center;justify-content: center;margin-top:.22rem;height:.28rem;
          span{
            font-size: .32rem;font-weight: 400;color: #2B84FC;
          }
          b{
            font-size: .28rem;font-weight: 400;color: #2B84FC;margin-left:.52rem;
          }
        }
        .msg{
          /* margin-top:.48rem; */
        }
        .code{
          width:100%;display:block;margin:.2rem auto 0;
        }
      }
    }
    .close{
      width:.7rem;height:.7rem;margin:.6rem auto 0;border-radius:50%;overflow:hidden;transition: all .25s;
      img{
        width:100%;height:100%;display:block;
      }
    }
  }
  .component2.show{
    visibility: show;background: rgba(0,0,0,.7);
  }
  .component2.hide{
    visibility: hidden;
    .componentor,.close{
      opacity: 0;
    }
  }

`;